import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/index.css';
import RouterIndex from './Route';

ReactDOM.render(<RouterIndex />, document.getElementById('root'));
